<template>

    <div class="flash flash--modal">
        <!-- Modal -->
        <div :class="modelValue ? 'show': ''" class="modal modal--flash fade" id="flashModal" tabindex="-1" role="dialog"
            aria-labelledby="flashModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">

                    <div class="modal-header justify-content-between">
                        <h5 class="modal-title text-black">
                            <!-- form title -->
                            {{ title }}
                        </h5>

                        <button class="btn" type="button" data-bs-dismiss="modal" aria-label="Close"
                        @click="closeModal"><i class="icon-close"></i></button>
                    </div>

                    <div class="modal-body py-5">

                        <div class="flash__text text-center">

                            <template v-if="status">
                                <!-- Success message block -->

                                <span class="text-success mb-3">
                                    <IconCircleCheck :size="200" stroke-width="1" />
                                </span>

                                <span class="d-block text-success heading-h4 mb-3">
                                    Successfully!
                                </span>
                                <span class="d-block text-success">
                                    {{ message }}
                                </span>

                            </template>

                            <template v-else>

                                <!-- Error message block -->

                                <span class="text-danger mb-3">
                                    <IconCircleX :size="200" stroke-width="1" />
                                </span>

                                <span class="d-block text-danger heading-h4 mb-3">
                                    Error!
                                </span>
                                <span class="d-block text-danger">
                                    {{ message }}
                                </span>

                            </template>


                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script setup>

import { IconCircleCheck, IconCircleX } from '@tabler/icons-vue';

const props = defineProps({
    title: {
        type: String
    },
    message: {
        type: String
    },
    status: {
        type: Boolean
    },
    modelValue: {
        type: Boolean
    }
});

const emit = defineEmits(['update:modelValue']);

const closeModal = () => {
    const modal = document.getElementById('flashModal')
    modal.classList.remove('show')
    emit('update:modelValue', false);
}

</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";
.modal{
    &.modal--flash {
        background: rgba(0, 0, 0, .5);

        .btn{
            @include hover-focus-active {
                color: $green-2;
            }
        }
        &.show {
            display: block;

            .modal-dialog {
                transform: translateY(-50px);
            }
        }
    }
}
</style>
